export default __webpack_public_path__ + "img/cover.jpg.webp";